module.exports = __webpack_public_path__ + "static/media/myAthinaCourse.9df62a03.png";